
export class ResponsiveStore {
  isMobile?: boolean;
  isTablet?: boolean;
  isDesktop?: boolean;
  currentWindowWidth?: number;
}
